module.exports = __webpack_public_path__ + "img/client1.8f4e1855.gif";